import classNames from 'classnames'
import Icon from '../icon'

export const TrendText = ({
  value,
  suffixText = 'in the past week',
  invertColor = false,
}: {
  value: number
  suffixText?: string
  invertColor?: boolean
}) => {
  return (
    <p
      className={classNames('text-sm flex gap-[2px] items-center', {
        'text-danger':
          (value < 0 && !invertColor) || (value >= 0 && invertColor),
        'text-success':
          (value >= 0 && !invertColor) || (value < 0 && invertColor),
      })}
    >
      <Icon
        id="arrow-upright"
        width={16}
        height={16}
        className={classNames({
          'rotate-90': value < 0,
          'rotate-45': value === 0,
        })}
      />
      <span>
        {Math.abs(value)}% {value < 0 ? 'decrease' : 'increase'}
        {` ${suffixText}`}
      </span>
    </p>
  )
}
